function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1685 8.98438C10.8406 8.98438 10.622 9.3125 10.622 9.53125V12.2656H9.52903V9.53125C9.52903 9.20312 9.31043 8.98438 8.98253 8.98438C8.65462 8.98438 8.43602 9.3125 8.43602 9.53125V12.2656H7.34301V9.53125C7.34301 9.20312 7.12441 8.98438 6.79651 8.98438C6.4686 8.98438 6.25 9.3125 6.25 9.53125V13.1406C6.25 14.125 7.01511 14.8906 7.88952 15V22.6562C7.88952 23.3125 8.32672 23.75 8.98253 23.75C9.63833 23.75 10.0755 23.3125 10.0755 22.6562V15C10.9499 14.8906 11.7151 14.125 11.7151 13.1406V9.53125C11.7151 9.3125 11.4964 8.98438 11.1685 8.98438ZM13.3546 9.53125V16.0938H14.4476V22.6562C14.4476 23.3125 14.8848 23.75 15.5406 23.75C16.1964 23.75 16.6336 23.3125 16.6336 22.6562V6.25C14.7755 6.25 13.3546 7.67188 13.3546 9.53125ZM21.0056 8.4375C19.4754 8.4375 18.2731 10.0781 18.2731 12.0469C18.1638 13.3594 18.8196 14.5625 19.9126 15.3281V22.6562C19.9126 23.3125 20.3498 23.75 21.0056 23.75C21.6614 23.75 22.0987 23.3125 22.0987 22.6562V15.3281C23.1917 14.5625 23.8475 13.3594 23.7382 12.0469C23.7382 10.0781 22.5359 8.4375 21.0056 8.4375Z",
  fill: "white"
});

function SvgGastronomy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGastronomy);
export default __webpack_public_path__ + "static/media/gastronomy.5800bf19.svg";
export { ForwardRef as ReactComponent };